import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Menu, Layout, Flex, Row, Col, Button } from "antd";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { setSidebarCollapsed } from "../../redux/Slices/LayoutSlice";
import { ROUTES_MAP } from "../../routes/routesMap";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { buildMenuItems, useMenuSelectedKeys } from "./menuConfig";
import { BrandMark } from "../../Components/BrandMark/BrandMark";

const { Sider } = Layout;

export const Sidebar: React.FC = () => {
  const breakpoint = Grid.useBreakpoint();
  const { sidebarCollapsed } = useAppSelector((state) => state.layout);
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const { t } = useTranslation("dashboard");

  const selectedKeys = useMenuSelectedKeys(t, user);

  const onMenuItemClick = () => {
    if (!breakpoint.sm) {
      dispatch(setSidebarCollapsed(false));
    }
  };

  useEffect(() => {
    if (!breakpoint.sm) {
      dispatch(setSidebarCollapsed(true));
    } else {
      dispatch(setSidebarCollapsed(false));
    }
  }, [breakpoint.sm]);

  return (
    <Sider
      className="sidebar"
      collapsed={sidebarCollapsed}
      width={250}
      collapsedWidth={80}
    >
      <Button
        size="small"
        shape="circle"
        className="st-sider-toggle"
        aria-label={t(sidebarCollapsed ? "nav.expandSidebar" : "nav.collapseSidebar")}
        icon={sidebarCollapsed ? <RightOutlined /> : <LeftOutlined />}
        onClick={() => dispatch(setSidebarCollapsed(!sidebarCollapsed))}
      />
      <Row>
        <Col xs={0} md={24}>
          <Flex
            justify="flex-start"
            align="center"
            style={{ width: "100%", paddingLeft: sidebarCollapsed ? 10 : 24 }}
          >
            <div
              style={{
                margin: "20px 0",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Link to={ROUTES_MAP.dashboard.liveStreams} style={{ display: "inline-flex" }}>
                <BrandMark size={40} label="Streaminal" />
              </Link>
              {!sidebarCollapsed && (
                <Link to={ROUTES_MAP.dashboard.liveStreams} className="st-sider__wordmark">
                  Streaminal
                </Link>
              )}
            </div>
          </Flex>
        </Col>
        <Col xs={24} md={0}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={ROUTES_MAP.dashboard.liveStreams} style={{ display: "inline-flex" }}>
              <BrandMark size={40} label="Streaminal" />
            </Link>
          </div>
        </Col>
      </Row>
      <Menu mode="inline" inlineCollapsed={sidebarCollapsed} selectedKeys={selectedKeys}>
        {buildMenuItems(t, user).map((item) =>
          item.key.includes("divider") ? (
            <Menu.Divider key={item.key} />
          ) : (
            <Menu.Item
              icon={item.icon}
              key={item.key}
              onClick={onMenuItemClick}
              style={
                sidebarCollapsed
                  ? undefined
                  : { paddingLeft: 12, paddingRight: 12 }
              }
            >
              <Link to={item.key}>{item.title}</Link>
            </Menu.Item>
          )
        )}
      </Menu>
    </Sider>
  );
};
